import { BehaviorSubject } from 'rxjs'

import { Injectable } from '@angular/core'

export interface SearchNavigationState {
    fromSearch: boolean
    searchQuery: string
    selectedFileId: number | null
}

/**
 * Service to manage navigation state when moving between search modal,
 * file details panel, and asset editor
 */
@Injectable({
    providedIn: 'root'
})
export class SearchNavigationService {
    private _navigationState = new BehaviorSubject<SearchNavigationState>({
        fromSearch: false,
        searchQuery: '',
        selectedFileId: null
    })

    public navigationState$ = this._navigationState.asObservable()

    get currentState(): SearchNavigationState {
        return this._navigationState.value
    }

    /**
     * Save the current search context when navigating to asset editor
     */
    saveSearchContext(query: string, fileId: number | null = null): void {
        this._navigationState.next({
            fromSearch: true,
            searchQuery: query,
            selectedFileId: fileId
        })
    }

    /**
     * Clear search context (e.g., when closing search modal manually)
     */
    clearSearchContext(): void {
        this._navigationState.next({
            fromSearch: false,
            searchQuery: '',
            selectedFileId: null
        })
    }

    /**
     * Check if we're currently in a search navigation flow
     */
    isInSearchFlow(): boolean {
        return this._navigationState.value.fromSearch
    }
}
